import {Component, OnInit} from '@angular/core';
import {
  fadeInLeftOnEnterAnimation,
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation,
  fadeOutRightOnLeaveAnimation
} from 'angular-animations';

import Talk from 'talkjs';
import {ConferenceService} from '../../conference/service/conference.service';
import {TalkJSModel} from '../../conference/models/talkjs.model';


@Component({
  selector: 'talkjs-page',
  templateUrl: './talkjs.page.html',
  styleUrls: ['./talkjs.page.scss'],
  animations: [
    fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
    fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
    fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
    fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
  ]
})

export class TalkjsPage implements OnInit {

  talkInfo: TalkJSModel = null;

  constructor(
    private conferenceService: ConferenceService,
  ) {
  }

  ngOnInit() {
    this.initTalkJS();
  }

  initTalkJS() {
    Talk.ready.then((): void => {
      const me = new Talk.User('sample_user_sebastian');
      const session = new Talk.Session({
        appId: 'tZfC5e36',
        me: me
      });

      const conversation = session.getOrCreateConversation(
        'sample_conversation'
      );
      conversation.setParticipant(me);

      const chatbox = session.createChatbox();
      chatbox.select(conversation);
      chatbox.mount(document.getElementById('talkjs-container'));
    });


  }


}
